import { observer } from 'mobx-react'
import React from 'react'

import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'
import {
  ExtendedColumnCell,
  ExtendedHeaderGroupCell,
} from '@new/domains/fastBookingsTapeChart/__commonStyles'
import { arrivalModeColumnStore } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalModeColumns/ArrivalModeColumnStore'
import { CaseTabs } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalsChecklistSidePanel/ArrivalsChecklist.types'
import { ExtendedColumnGroups } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.types'
import { HomeExtendedInfo } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartStore'

import { CheckListStatus } from './CheckListStatus'

const columnWidth = 50

export const InspectStatusHeader = () => {
  return (
    <ExtendedHeaderGroupCell
      key={`col-header-${ExtendedColumnKey.inspectStatus}`}
      width={columnWidth}
    >
      Inspect
    </ExtendedHeaderGroupCell>
  )
}

const InspectStatusCell = observer(({ home }: { home?: HomeExtendedInfo }) => {
  if (!home?.id) return <ExtendedColumnCell width={columnWidth}>-</ExtendedColumnCell>

  const inspectionCases = arrivalModeColumnStore.homeStatuses.get(home.id)?.inspectedDetails
  const checklistStatus = inspectionCases?.status
  const hasCases = (inspectionCases?.total ?? 0) > 0

  return (
    <CheckListStatus
      caseTab={CaseTabs.inspections}
      checklistStatus={checklistStatus}
      columnWidth={columnWidth}
      hasCases={hasCases}
      home={home}
    />
  )
})

export const InspectStatus = {
  header: <InspectStatusHeader />,
  columnKey: ExtendedColumnKey.inspectStatus,
  groupId: ExtendedColumnGroups.arrivalsChecklist,
  width: columnWidth,
  renderer: (home?: HomeExtendedInfo) => (
    <InspectStatusCell key={`col-${ExtendedColumnKey.inspectStatus}-${home?.id}`} home={home} />
  ),
}
